var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoggedIn)?_c('free-newsroom-button'):(_vm.$hasAccess('company'))?_c('newsrooms-dropdown'):(_vm.$hasAccess('reader'))?_c('journalist-dashboard-link'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }